module.exports = __webpack_public_path__ + "img/Recipe-DiYiZhenSuo.1215dc18.png";